export class ConfigIsEmptyError extends Error {
    constructor() {
        super('The config is empty.');
        // Todo: Only works in Chrome and FireFox, does not work in IE
        Object.setPrototypeOf(this, ConfigIsEmptyError.prototype);
    }
}
